import { httpClient } from '../http/httpClient'

interface ConfigureConsultsPayload {
  j17?: boolean
  qitech?: boolean
}

export async function configureConsults(
  payload: ConfigureConsultsPayload,
): Promise<void> {
  await httpClient.post('/config/consult', payload)
}
